import styled from 'styled-components'

/**
 * Footer action row (Cancel + submit), right-aligned. The 24px top offset
 * separates it from the divider (the Figma action section uses 24px padding);
 * the modal card provides the bottom padding.
 */
export const FormActionsStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${(props) => props.theme.typography.pxToRem(8)};
  padding-top: ${(props) => props.theme.typography.pxToRem(24)};
`
